import axios from 'axios';
import Spinner from '../../spinner/spinner';
import React from 'react';
import { ServiceRegistry } from '../../../models/service-registry';
import { SubscriptionService } from '../../../models/subscription-service';
import { createChatBotMessage, createCustomMessage } from "react-chatbot-kit";

class MessageParser {
  constructor(actionProvider) {
    this.actionProvider = actionProvider;
  }

  parse(message) {
    if (message && typeof message === 'string' && message.trim()) {
      this.handleUserInput(message.trim());
    } else {
      this.actionProvider.handleOptions();
    }
  }

  handleUserInput(userMessage) {
    this.actionProvider.handleUserInput && this.actionProvider.handleUserInput(userMessage);
  }
}

export default MessageParser;
